import dayjs from 'dayjs';

const SHORT_MODALITY_LABELS: Record<string, string> = {
  TTE: 'Echo',
  STRESS_ECHO: 'SE',
  ULTRASOUND: 'US',
};

export function formatModalityShort(
  modality: string | null | undefined
): string {
  if (!modality) return '—';
  return SHORT_MODALITY_LABELS[modality] ?? modality;
}

export function formatPriorStudyDate(
  isoDate: string | null | undefined
): string {
  if (!isoDate) return '—';
  const d = dayjs(isoDate);
  if (!d.isValid()) return '—';
  return d.format('MMM D, YYYY');
}
